<template>
  <div>
    <label>Farbschema*</label>
    <div class="row">
      <div class="col-3" v-for="scheme in availableSchemes" :key="`scheme-${scheme}`" @click="onSchemeClick(scheme)">
        <ci-awesome-icon icon="check" class="position-absolute ml-2 mt-2" v-if="selectedScheme === scheme" ratio="0.5" />
        <div :class="`${scheme} w-100 scheme`" style="height: 50px; display: block;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AwesomeIcon from '@/components/AwesomeIcon.vue';

export default {
  name: 'ColorScheme',

  components: {
    'ci-awesome-icon': AwesomeIcon,
  },

  props: {
    selectedScheme: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      availableSchemes: ['orange', 'green', 'blue', 'red'],
    };
  },

  methods: {
    onSchemeClick(scheme) {
      this.$emit('color-scheme:selected', scheme);
    },
  },
};
</script>

<style lang="scss">
.scheme {
  &:hover {
    cursor: pointer;
  }
}
.orange {
  background: #fad961; /* Old browsers */
  background: -moz-linear-gradient(top, #fad961 0%, #f76b1c 100%);
  background: -webkit-linear-gradient(top, #fad961 0%,#f76b1c 100%);
  background: linear-gradient(to bottom, #fad961 0%,#f76b1c 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fad961', endColorstr='#f76b1c',GradientType=0 );
}

.green {
  background: #54c100; /* Old browsers */
  background: -moz-linear-gradient(top, #54c100 0%, #429321 100%);
  background: -webkit-linear-gradient(top, #54c100 0%,#429321 100%);
  background: linear-gradient(to bottom, #54c100 0%,#429321 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#54c100', endColorstr='#429321',GradientType=0 );
}

.blue {
  background: #4b91e3;
  background: -moz-linear-gradient(top, #4b91e3 0%, #2A74CB 100%);
  background: -webkit-linear-gradient(top, #4b91e3 0%,#2A74CB 100%);
  background: linear-gradient(to bottom, #4b91e3 0%,#2A74CB 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4b91e3', endColorstr='#2A74CB',GradientType=0 );
}

.red {
  background: rgb(248,83,89);
  background: -moz-linear-gradient(top, rgba(248,83,89,1) 0%, rgba(93,26,28,1) 100%);
  background: -webkit-linear-gradient(top, rgba(248,83,89,1) 0%,rgba(93,26,28,1) 100%);
  background: linear-gradient(to bottom, rgba(248,83,89,1) 0%,rgba(93,26,28,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f85359', endColorstr='#5d1a1c',GradientType=0 );
}
</style>
